/**
 *? Notification Styles
 */

/**
 ** Write your tailwind classes as objects and strings and import them in your component
 */

export const baseStyles = '';

export const themes = {
  theme_default: {
    main: '',
    textColor: '',
  },
};
